import React from "react";
import { List, ListItem, Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import bee from "../../assets/bee.gif";
import bear from "../../assets/bear.gif";
import star from "../../assets/star.gif";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const About = () => {
    return (
        <Box sx={{
            marginTop: "20px",
            padding: "100px",
            animation: `${fadeIn} 0.5s ease-in`
        }}>
            {/* Top Section: Author Image & Introduction */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
                {/* Left: Author Image */}
                <Box sx={{ flex: 1 }}>
                    <img
                        src={bear}
                        alt="Author"
                        style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            border: "1px solid #ddd"  // Added border color
                        }}
                    />
                </Box>
                {/* Right: Introduction */}
                <Box sx={{ flex: 2 }}>
                    <Typography variant="h5" fontWeight="bold">介紹</Typography>
                    <Typography variant="body1" sx={{ marginTop: "10px", fontSize: "14px" }}>
                        我喜歡觀察日常裡的小細節，用溫柔的線條和柔和的色彩，把生活中那些幽默、有趣、甚至有點詩意的瞬間畫下來。<br />
                        創作對我來說，是一種情感的記錄。我喜歡透過圖像捕捉情感與氛圍，讓觀者在視覺中感受到情緒的流動，並與作品產生共鳴。
                    </Typography>
                    <Typography variant="h5" fontWeight="bold" sx={{ marginTop: "60px" }}>Introduction</Typography>
                    <Typography variant="body1" sx={{ marginTop: "10px", fontSize: "14px" }}>
                        I enjoy observing small details in everyday life, using gentle lines and soft colours to capture moments that are humorous, touching, or quietly poetic.
                        For me, illustration is a way of recording emotions.<br /> I like to express feelings and atmosphere through images, allowing viewers to sense an emotional flow and connect with the work on a more personal level.
                    </Typography>
                </Box>
            </Box>

            {/* Bottom Section: Four Blocks */}
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", marginTop: "40px" }}>
                <Box sx={{ border: "1px solid #ddd", padding: "20px", textAlign: "center", borderRadius: "8px", }}>
                    <Typography variant="h6" fontWeight="bold">合作廠商</Typography>
                    <Typography variant="body1">TEST</Typography>
                </Box>
                <Box sx={{ border: "1px solid #ddd", padding: "20px", textAlign: "center", borderRadius: "8px", }}>
                    <Typography variant="h6" fontWeight="bold">經歷</Typography>
                    <List sx={{ paddingLeft: "20px", textAlign: "center", listStyleType: "disc" }}>
                        <ListItem>
                            <Typography variant="body1">TEST</Typography>
                        </ListItem>
                        <ListItem>
                            <Typography variant="body1">TEST</Typography>
                        </ListItem>
                        {/* Add more ListItems as needed */}
                    </List>
                </Box>

                <Box sx={{ border: "1px solid #ddd", padding: "20px", textAlign: "center", borderRadius: "8px", }}>
                    <Typography variant="h6" fontWeight="bold">設計項目</Typography>
                    <Typography variant="body1">TEST</Typography>
                </Box>
                <Box sx={{ border: "1px solid #ddd", padding: "20px", textAlign: "center", borderRadius: "8px", }}>
                    <Typography variant="h6" fontWeight="bold">寄賣店家</Typography>
                    <Typography variant="body1">TEST</Typography>
                </Box>
            </Box>

        </Box>
    );
};

export default About;
